import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { Link, useNavigate } from "react-router-dom";
import { ADDRESSES, ABIS } from "../utils/contracts";

export default function FakeNefturians() {
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userAddress, setUserAddress] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
        if(window.ethereum) {
            const provider = new ethers.BrowserProvider(window.ethereum);
            const contract = new ethers.Contract(ADDRESSES.NEFTURIANS, ABIS.NEFTURIANS, provider);
            
            // Get Price
            const _price = await contract.tokenPrice();
            setPrice(_price);
            
            // Get User Address
            const signer = await provider.getSigner();
            setUserAddress(signer.address);
        }
    }
    init();
  }, []);

  const buyToken = async () => {
    if (!price) return;
    setLoading(true);
    try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const contract = new ethers.Contract(ADDRESSES.NEFTURIANS, ABIS.NEFTURIANS, signer);

        const balance = await contract.balanceOf(signer.address);
        if (balance > 0n) {
             alert("You already own a Nefturian! This contract might limit 1 per wallet.");
             setLoading(false);
             return;
        }

        console.log("Calling buyAToken...");
        const tx = await contract.buyAToken({ 
            value: price 
        });
        
        console.log("Tx sent:", tx.hash);
        await tx.wait();
        alert("Success!");
        
    } catch (err) {
        console.error("Purchase Error:", err);

        if (err.message.includes("reverted")) {
            alert("Transaction reverted. Do you already own a token?");
        }
    }
    setLoading(false);
};

  return (
    <div>
      <h1>Fake Nefturians</h1>
      <p>Price: {price ? ethers.formatEther(price) : "..."} ETH</p>
      <button onClick={buyToken} disabled={loading || !price}>
        {loading ? "Buying..." : "Buy Token"}
      </button>
      
      <hr />
      
      <h3>Your Wallet</h3>
      {userAddress && (
          <button onClick={() => navigate(`/fakeNefturians/${userAddress}`)}>
              View My Tokens
          </button>
      )}
    </div>
  );
}